export var CLEAR_ONION_FORM = 'CLEAR_ONION_FORM';
export var CLEAR_ONION_FORM_PROPERTY = 'CLEAR_ONION_FORM_PROPERTY';
export var SET_ONION_FORM_FIELD_PROPERTY = 'SET_ONION_FORM_FIELD_PROPERTY';
export var SET_ONION_FORM_MULTIPLE_FIELDS = 'SET_ONION_FORM_MULTIPLE_FIELDS';
export var SET_ONION_FORM_FIELD_ERROR = 'SET_ONION_FORM_FIELD_ERROR';
/**
* Action for setting multiple form fields at once
* @param {string} form - name of the form
* @param {string} property - which property of the field to set (e.g. 'value', 'error', 'apiError', 'liveValidation')
* @param {Object} values - contains which fields in form should be set to what
* @return {Object} declared action
*/

export function setMultipleFields(form, property, values) {
  return {
    type: SET_ONION_FORM_MULTIPLE_FIELDS,
    form: form,
    property: property,
    values: values
  };
}
/**
* Action for setting single form field
* @param {string} form - name of the form
* @param {string} field - field in the form
* @param {string} property - which property of the field to set (e.g. 'value', 'error', 'apiError', 'liveValidation')
* @param {string|number} value - which value should field's property be set to
* @return {Object} declared action
*/

export function setFormFieldProperty(form, field, property, value) {
  return {
    type: SET_ONION_FORM_FIELD_PROPERTY,
    form: form,
    field: field,
    property: property,
    value: value
  };
}
/**
* Action for setting an error on single form field
* @param {string} form - name of the form
* @param {string} field - field in the form
* @param {string|null} value - which value should field's property 'error' be set to
* @return {Object} declared action
*/

export function setFormFieldError(form, field, value) {
  return {
    type: SET_ONION_FORM_FIELD_ERROR,
    form: form,
    field: field,
    value: value
  };
}
/**
* Action for clearing a property on all form fields
* @param {string} form - name of the form
* @param {string} property - which property of the field to clear (e.g. 'value', 'error', 'apiError', 'liveValidation')
* @return {Object} declared action
*/

export function clearFormProperty(form, property) {
  return {
    type: CLEAR_ONION_FORM_PROPERTY,
    form: form,
    property: property
  };
}
/**
* Action for clearing whole form with all its fields
* @param {string} form - name of the form
* @return {Object} declared action
*/

export function clearForm(form) {
  return {
    type: CLEAR_ONION_FORM,
    form: form
  };
}
/**
* Action for setting a value property on a form
* @param {string} form - name of the form
* @param {string} field - field in the form
* @param {string|number} value - which value should be set on a field
* @return {Object} declared action
*/

export function setFieldValue(form, field, value) {
  return setFormFieldProperty(form, field, 'value', value);
}
/**
* Action for setting field's live validation on
* @param {string} form - name of the form
* @param {string} field - field in the form
* @return {Object} declared action
*/

export function setFieldLiveValidation(form, field) {
  return setFormFieldProperty(form, field, 'liveValidation', true);
}
/**
* Action for setting an error on a form field
* @param {string} form - name of the form
* @param {string} field - field in the form
* @param {string|null} error - which value should field's property 'error' be set to
* @return {Object} declared action
*/

export function setFieldError(form, field, error) {
  return setFormFieldProperty(form, field, 'error', error);
}
/**
* Action for setting an apiError on a form field
* @param {string} form - name of the form
* @param {string} field - field in the form
* @param {string|null} error - which value should field's property 'apiError' be set to
* @return {Object} declared action
*/

export function setFieldApiError(form, field, error) {
  return setFormFieldProperty(form, field, 'apiError', error);
}
/**
* Makes all the actions of package to have form name set by default
* @param {string} form - name of the form
* @return {Object} declared action
*/

export default function createFormActions(form) {
  return {
    clearFormProperty: clearFormProperty.bind(null, form),
    setFieldApiError: setFieldApiError.bind(null, form),
    setFieldLiveValidation: setFieldLiveValidation.bind(null, form),
    setFieldError: setFieldError.bind(null, form),
    setFieldValue: setFieldValue.bind(null, form),
    setFormFieldProperty: setFormFieldProperty.bind(null, form),
    setMultipleFields: setMultipleFields.bind(null, form)
  };
}